const fixedBarBreakpointHome = 230;
const fixedBarBreakpoint = 110;

export default class SideMenu {
  sideMenu;
  toggleButtons;
  closeButtons;
  openButtons;
  navMenuFixed;

  constructor(sideMenu) {
    this.sideMenu = sideMenu;
    this.toggleButtons = document.getElementsByClassName('site-side-menu-toggle');
    this.closeButtons = document.getElementsByClassName('site-side-menu-close');
    this.openButtons = document.getElementsByClassName('site-side-menu-open');
    this.navMenuFixed = document.querySelector('.nav-menu-fixed');
    this.bindListeners();
  }

  bindListeners() {
    for( let closeButton of this.closeButtons ) {
      closeButton.addEventListener('click', this.close.bind(this));
    }

    for( let toggleButton of this.toggleButtons ) {
      toggleButton.addEventListener('click', this.toggle.bind(this));
    }

    for( let openButton of this.openButtons ) {
      openButton.addEventListener('click', this.open.bind(this));
    }

    window.addEventListener('scroll', this.setNavbarMode.bind(this));
  }

  open() {
    document.body.classList.add('is-menu-open');
    this.sideMenu.classList.add('open');
  }

  close() {
    document.body.classList.remove('is-menu-open');
    this.sideMenu.classList.remove('open');
  }

  toggle() {
    if(!this.sideMenu.classList.contains('open')) {
      this.open();
    }
    else {
      this.close();
    }
  }

  setNavbarMode() { 
    if (document.body.classList.contains('home')) {
      if ((window.pageYOffset || document.documentElement.scrollTop) > fixedBarBreakpointHome) {
        this.navMenuFixed.classList.add('open');
      }
      else {
        this.navMenuFixed.classList.remove('open');
      }
    }
    else { 
      if ((window.pageYOffset || document.documentElement.scrollTop) > fixedBarBreakpoint) {
        this.navMenuFixed.classList.add('open');
      }
      else {
        this.navMenuFixed.classList.remove('open');
      }
    }
  }
}


// WEBPACK FOOTER //
// ./ui/assets/js/SideMenu/SideMenu.js